import { IFrameComponent } from 'iframe-resizer-react';
import { useLocation } from 'react-router-dom';
import { useAppDispatch } from '../../hooks';

import { setChatOpen, setChatClosed } from '../../store/ChatBotSlice';


type IFrameResizerEvent = {
  iframe: IFrameComponent;
  id?: string;
  height: number;
  width: number;
  type: string;
}

const useChatBot = () => {

  const location = useLocation();
  const displayIframe = (location.pathname === '/settings') ?
    'none' :
    'block';

  const dispatch = useAppDispatch();

  const onResized = ({ height }:IFrameResizerEvent) => {
    if (height>100) {
      dispatch(setChatOpen());
    } else {
      dispatch(setChatClosed());
    }
  };

  return { displayIframe, onResized };
};

export default useChatBot;
